module.exports = __webpack_public_path__ + "media/images/top/introduction/img_hero-d9fab92b3ae14b8035831b61217d479a.png";